import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {LoginState} from '@local/redux/state/pages/login';

const initialState: LoginState = {
  email: '',
  processing: false,
};
const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<Partial<LoginState>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    clear: () => initialState,
  },
});
export const loginReducer = loginSlice.reducer;
export const loginActions = loginSlice.actions;
